'use client';

import Image from 'next/image';
import Link from 'next/link';

const MediaPartnersLogoSection = () => {
const logos = [
  {
    src: "/images/zuddi-logo.webp",
    alt: "zuddl-logo",
    link: "https://www.zuddl.com/platform/virtual-and-hybrid-events/ai-content-hub",
  },
  {
    src: "/images/bftimes.webp",
    alt: "bftimes",
    link: "https://bfmtimes.com/",
  },
  {
    src: "/images/techedgeai-logo.webp",
    alt: "techedgeai-logo",
    link: "https://techedgeai.com/",
  },
  {
    src: "/images/techznw-logo.webp",
    alt: "techznow-logo",
    link: "http://www.techznow.com/",
  },
  {
    src: "/images/ai-pressroom.webp",
    alt: "ai-pressroom",
    link: "https://aipressroom.com/",
  },
  {
    src: "/images/aimojo-logo.webp",
    alt: "aimojo-logo",
    link: "https://aimojo.io/",
  },
  {
    src: "/images/gogetgpt.webp",
    alt: "gogetgpt",
    link: "https://gogetgpt.com/",
  },
  {
    src: "/images/strtupcity-logo.webp",
    alt: "startupcity-logo",
    link: "https://www.startupcity.com/",
  },
  {
    src: "/images/ai-tools-network-logo.webp",
    alt: "ai-tools-network-logo",
    link: "https://aitoolsnetwork.com/artificial-intelligence-events/",
  },
  {
    src: "/images/aiedgeInsights-logo.webp",
    alt: "aiedgeinsights-logo",
    link: "http://www.aiedgeinsights.com/",
  },
  {
    src: "/images/fvmglobal.webp",
    alt: "FVM Global",
    link: "https://www.fvmglobal.com/",
  },
  {
    src: "/images/cioreview.webp",
    alt: "CIOReview",
    link: "https://www.cioreview.com/",
  },
  {
    src: "/images/nendigital-logo.webp",
    alt: "nendigital-logo",
    link: "http://www.nendigital.com/",
  },
  {
    src: "/images/gignomist-logo.webp",
    alt: "gignomist-logo",
    link: "https://gignomist.com/",
  },
  {
    src: "/images/logo-africa.webp",
    alt: "IT Edge News Africa",
    link: "https://www.itedgenews.africa/",
  },
  {
    src: "/images/smartmoneymatch.webp",
    alt: "Smart Money Match",
    link: "https://www.smartmoneymatch.com/help/media-partnerships",
  },
  {
    src: "/images/transportstake.webp",
    alt: "Transport Stake",
    link: "https://www.transportstake.com/",
  },
  {
    src: "/images/publicitymarketplace.webp",
    alt: "Publicity Marketplace",
    link: "https://www.publicitymarketplace.com/en/media-library",
  },
  {
    src: "/images/functionalsourcing-logo.webp",
    alt: "Functional Sourcing",
    link: "https://www.functionalsourcing.com/en/media-library",
  },
  {
    src: "/images/education-stake.webp",
    alt: "Education Stake",
    link: "https://www.educationstake.com/en/media-library",
  },
  {
    src: "/images/matchsdg-logo.webp",
    alt: "MatchSDG",
    link: "https://www.matchsdg.com/en/media-library",
  },
  {
    src: "/images/expotobi.webp",
    alt: "ExpoTobi",
    link: "https://expotobi.in/",
  },
  {
    src: "/images/the-tech-news-portal.webp",
    alt: "the-tech-news-portal",
    link: "https://thetechnewsportal.com/",
  },
  {
    src: "/images/enterprise-viewpoint.webp",
    alt: "Enterprise Viewpoint",
    link: "https://enterpriseviewpoint.com/",
  },
  {
    src: "/images/grc-outlook-logo.webp",
    alt: "grc-outlook-logo",
    link: "https://grcoutlook.com/",
  },
   {
    src: "/images/bigdataanalyticsnews.webp",
    alt: "Big Data Analytics News",
    link: "https://bigdataanalyticsnews.com/",
  },
  {
    src: "/images/unite-ai.svg",
    alt: "Unite.AI",
    link: "https://www.unite.ai/",
  },
  {
    src: "/images/securityafricamagazine.webp",
    alt: "Security Africa Magazine",
    link: "https://securityafricamagazine.com/",
  },
  {
    src: "/images/digital-ink-media.webp",
    alt: "Digital Ink Media",
    link: "https://www.digitalinkmedia.ae/",
  },
  {
    src: "/images/aimlevents.webp",
    alt: "AI ML Events",
    link: "https://aiml.events/",
  },
  {
    src: "/images/huidu.webp",
    alt: "HuiDu",
    link: "https://www.huidu.cn/en",
  },
  {
    src: "/images/cxquest.webp",
    alt: "CXQuest",
    link: "https://cxquest.com/",
  },
  {
    src: "/images/mediapartnerslogo/ciotechoutlook.webp",
    alt: "CIO Tech Outlook",
    link: "https://www.ciotechoutlook.com/",
  },
  {
    src: "/images/industryevents.webp",
    alt: "Industry Events",
    link: "https://www.industryevents.com/",
  },
  {
    src: "/images/theglobalhues.webp",
    alt: "The Global Hues",
    link: "https://theglobalhues.com/",
  },
  {
    src: "/images/innmind.webp",
    alt: "InnMind",
    link: "https://innmind.com/",
  },
  {
    src: "/images/cionews.webp",
    alt: "CIO News",
    link: "https://cionews.co.in/",
  },
  {
    src: "/images/zexprwire-logo.webp",
    alt: "zexprwire",
    link: "https://zexprwire.com/",
  },
];


  return (
    <section data-component-id="src/app/MediaPartnersLogoSection.tsx:202:4" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="202" data-component-end-line="240" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20max-w-%5B1100px%5D%20mx-auto%20py-10%20bg-white%22%7D" className="w-full max-w-[1100px] mx-auto py-10 bg-white">
      <div data-component-id="src/app/MediaPartnersLogoSection.tsx:203:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="203" data-component-end-line="239" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-8%20items-center%20w-full%20max-w-%5B1340px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="flex flex-col gap-8 items-center w-full max-w-[1340px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Heading */}
        <div data-component-id="src/app/MediaPartnersLogoSection.tsx:206:8" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="206" data-component-end-line="210" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
          <h2 data-component-id="src/app/MediaPartnersLogoSection.tsx:207:10" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="207" data-component-end-line="209" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B30px%5D%20lg%3Atext-%5B40px%5D%20font-%5B'Michroma'%5D%20font-normal%20leading-tight%20text-%5B%236f4afc%5D%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-[20px] sm:text-[30px] lg:text-[40px] font-['Michroma'] font-normal leading-tight text-[#6f4afc]">
            Media Partners 
          </h2>
        </div>


{/* Logos Grid */}
<div data-component-id="src/app/MediaPartnersLogoSection.tsx:214:0" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="214" data-component-end-line="238" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-4%20lg%3Agrid-cols-6%20gap-6%20w-full%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6 w-full">
  {logos.map((logo, index) => (
    <a data-component-id="src/app/MediaPartnersLogoSection.tsx:216:4" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="216" data-component-end-line="236" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22rounded-lg%20flex%20items-center%20justify-center%20w-full%20%5Cr%5Cn%20%20%20%20%20%20h-%5B70px%5D%20sm%3Ah-%5B90px%5D%20md%3Ah-%5B100px%5D%20p-2%20sm%3Ap-4%20hover%3Ashadow-md%20transition-all%22%7D"
      key={index}
      href={logo.link}
      target="_blank"
      rel={
        logo.link === "https://www.cryptonewsz.com/"
          ? "noopener noreferrer"
          : "noopener noreferrer nofollow"
      }
      className="rounded-lg flex items-center justify-center w-full 
      h-[70px] sm:h-[90px] md:h-[100px] p-2 sm:p-4 hover:shadow-md transition-all"
    >
      <Image data-component-id="src/app/MediaPartnersLogoSection.tsx:228:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="228" data-component-end-line="235" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-full%20h-full%20max-h-full%20scale-%5B1.15%5D%20sm%3Ascale-%5B1.2%5D%20transition-transform%22%7D"
  src={logo.src}
  alt={logo.alt}
  width={220}
  height={120}
  unoptimized
  className="object-contain w-full h-full max-h-full scale-[1.15] sm:scale-[1.2] transition-transform"
/>
    </a>
  ))}
</div>
      </div>
    </section>
  );
};

export default MediaPartnersLogoSection;
